import { Location } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { DefaultUrlSerializer } from '@angular/router';
import { IrisStorage } from './storage';

@Injectable({
  providedIn: 'root',
})
export class IrisUrlStorage implements IrisStorage {
  private readonly location = inject(Location);

  getItem<T>(key: string): T | undefined {
    const httpParams = this.getQueryParams();

    if (!httpParams.has(key)) {
      return undefined;
    }

    try {
      return JSON.parse(httpParams.get(key)) as T;
    }
    catch {
      return undefined;
    }
  }

  setItem<T>(key: string, value: T): void {
    const json = JSON.stringify(value, (_key, value) => value ?? undefined);
    const emptyJson = '{}';

    if (json === emptyJson) {
      this.removeItem(key);
    }
    else {
      const httpParams = this.getQueryParams()
        .set(key, json);

      this.replaceQueryParams(httpParams);
    }
  }

  removeItem(key: string): void {
    const httpParams = this.getQueryParams()
      .delete(key);

    this.replaceQueryParams(httpParams);
  }

  private getQueryParams(): HttpParams {
    const path = this.location.path();
    const urlSerializer = new DefaultUrlSerializer();
    const queryParams = urlSerializer.parse(path).queryParams;
    return new HttpParams({ fromObject: queryParams });
  }

  private replaceQueryParams(httpParams: HttpParams): void {
    const path = this.location.path();
    const urlSerializer = new DefaultUrlSerializer();
    const urlTree = urlSerializer.parse(path);
    urlTree.queryParams = {};

    this.location.replaceState(urlSerializer.serialize(urlTree), httpParams.toString());
  }
}
